module.exports = __webpack_public_path__ + "static/media/figure_mobile_two.01245470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure_mobile_two.png
// module id = 541
// module chunks = 0